export class DataclipPaths {
  public static accounts_unverified_all = "https://data.heroku.com/dataclips/qponlxcegmimrnyprskjjklahdzm.csv";
  public static accounts_contract_signed = "https://data.heroku.com/dataclips/actqexiqfclctfhvzwbmopsljkcs.csv";
  public static accounts_approved_all = "https://data.heroku.com/dataclips/hejpnhigbcamqocucuoxdwgoqtev.csv";
  public static accounts_approved_new_account = "https://data.heroku.com/dataclips/kcoiytqflmbiektekswejqspcird.csv";
  public static accounts_approved_on_time = "https://data.heroku.com/dataclips/chtsdfkkefhzowpfvsomqkaaowum.csv";
  public static accounts_approved_overdue = "https://data.heroku.com/dataclips/nljillzfkgfqmpjnonacbeqiqgth.csv";
  public static accounts_approved_terminated = "https://data.heroku.com/dataclips/vftxeoavxcpowlmrfexzxqyxkiff.csv";

  public static payments_unverified = "https://data.heroku.com/dataclips/scmjslxtjiidpuybovarpjfnqjbp.csv";
  public static payments_methods_table = "https://data.heroku.com/dataclips/rozrylsqgcwixcxxwcdalsimylfv.csv";
  public static credit_behaviour_table = "https://data.heroku.com/dataclips/lnxaouiksqspdsrtrvvkwlfmkcgx.csv";
}
